import Classifier from "./ClassifierModel";

export enum MetadataType {
    Standard,
    Extended,
    ExtendedObject,
}

export interface MetadataClassifierField {
    type: MetadataType;
    classifierId: string;
    classifier: Classifier;
    fieldName: string;
    label: string;
}
